import { CIPStatisticPayload } from '../NewStatistics.types';

/**
 * Shared types for the CIPStatistic module.
 * Used by the container, the presentational components, the logic hook and their tests.
 */
export enum CIPStatisticTileType {
  Pending = 'Pending',
  Failed = 'Failed',
  Total = 'Total',
}

export interface CIPStatisticTileConfig {
  type: CIPStatisticTileType;
  testId: string;
  label: string;
  value?: number;
}

export interface CIPStatisticTileProps extends CIPStatisticTileConfig {
  isLoading?: boolean;
}

export interface UseCIPStatisticLogicParams {
  data: CIPStatisticPayload | null;
  isDataEmpty?: boolean;
  isConfigShowed?: boolean;
  isConfigLoading?: boolean;
}
